<template>
    <div class="componente-principal">
        <br/>
        <botao 
            type="button" 
            font_awesome_class="fas fa-dollar-sign" 
            label="Saldos de Caixa/Banco"
            @click.native="saldoCaixaBanco"/><br/>

        <botao 
            type="button" 
            font_awesome_class="fas fa-upload" 
            label="Contas a Pagar"
            @click.native="contasAPagar"/><br/>

        <botao 
            type="button" 
            font_awesome_class="fas fa-download" 
            label="Contas a Receber"
            @click.native="contasAReceber"/><br/>

        <botao 
            type="button"
            font_awesome_class="fas fa-exchange-alt" 
            label="Receitas/Despesas"
            @click.native="receitasDespesas"/><br/>

        <botao 
            type="button" 
            font_awesome_class="fas fa-chart-line" 
            label="Mapa de Produção"
            @click.native="mapaDeProducao"/><br/>
        
    </div>
</template>

<script>

import Botao from '@/components/shared/Botao.vue';
    
export default {
    name: 'Financeiro',
    components: {
        Botao
    },
    methods : {
        saldoCaixaBanco(){
            this.$router.push(`/saldos`);
        },
        contasAPagar(){
            this.$router.push(`/financeiro/contasapagar`);
            this.$emit('navigate', 'contasapagar');

        },
        contasAReceber(){
            this.$router.push(`/financeiro/contasareceber`);
            this.$emit('navigate', 'contasareceber');
        },
        receitasDespesas(){
            this.$router.push(`/financeiro/receitasdespesas`);
            this.$emit('navigate', 'receitasDespesas');      
        },
        mapaDeProducao(){
            this.$router.push(`/financeiro/mapaproducao`);
            this.$emit('navigate', 'mapaproducao');      
        }
    }
}
</script>

